"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _useFieldContext = _interopRequireDefault(require("../../../hooks/useFieldContext"));
var _useFormContext = _interopRequireDefault(require("../../../hooks/useFormContext"));
var _types = require("../../../../Hint/types");
var _react = require("react");
var _Group = _interopRequireDefault(require("./Group"));
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var ValidationMessages = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var formData = (0, _useFormContext.default)().formData;
  var fieldName = (0, _useFieldContext.default)().fieldName;
  var _a = (0, _react.useState)([]),
    groups = _a[0],
    setGroups = _a[1];
  (0, _react.useEffect)(function () {
    var _a;
    var unorderedGroupedMessages = (((_a = formData === null || formData === void 0 ? void 0 : formData[String(fieldName)]) === null || _a === void 0 ? void 0 : _a.validationMessages) || []).reduce(function (reducedGroups, message) {
      var _a;
      return __assign(__assign({}, reducedGroups), (_a = {}, _a[message === null || message === void 0 ? void 0 : message.type] = __spreadArray(__spreadArray([], reducedGroups[message === null || message === void 0 ? void 0 : message.type] || [], true), [message], false), _a));
    }, {});
    setGroups(Object.values(_types.HintTypes).reverse().reduce(function (orderedGroupedMessages, type) {
      return __spreadArray(__spreadArray([], orderedGroupedMessages, true), unorderedGroupedMessages[type] ? [unorderedGroupedMessages[type]] : [], true);
    }, []));
  }, [fieldName, formData]);
  return groups.length === 0 ? null : (0, _jsxRuntime.jsx)(Styled.Wrapper, __assign({
    ref: ref
  }, props, {
    children: groups.map(function (group, index) {
      return (0, _jsxRuntime.jsx)(_Group.default, {
        validationMessages: group
      }, index);
    })
  }));
});
var _default = ValidationMessages;
exports.default = _default;